import React from 'react';

/** Minimal placeholder while lazy route chunks load — avoids layout shift on Home. */
const RouteFallback: React.FC = () => (
  <div className="loading-screen" aria-busy="true" aria-label="Loading page" />
);

export default RouteFallback;
